module.exports = __webpack_public_path__ + "static/media/BigMart.31db5915.png";